import Vue from "vue";
import { Component, } from "vue-property-decorator";

export enum EntityOverwriteOptions {
    overwriteIfAlreadyExists,
    doNotOverwriteIfAlreadyExists,
    append

}

export interface IDashboardPublishOptions {
    overwriteOptions: EntityOverwriteOptions
}

@Component
export default class PublishToDashboardOptions extends Vue {

    options: IDashboardPublishOptions = { overwriteOptions: EntityOverwriteOptions.overwriteIfAlreadyExists };

    onOkClick() {
        this.$emit("dialogAccepted", this.options);
    }

    onCancelClick() {
        this.$emit("dialogCanceled", "");
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/publish-to-dashboard-options/publish-to-dashboard-options.ts